import { LoggedInAppArgs, LoggedInUser, ModalContent } from "../App";
import { BroadcastDiceRollResults, FalloutPrompt, GameData, GamePhase, NarrativeEvent, OpenFireRequest, PromptTakeAction, Quaternion, Vector3 } from "../Data/Response";
import React from "react";
import GameHeaderView from "./GameHeaderView";
import styles from './LoadedGame.module.scss';
import GamePlayerView from "./GamePlayerView";
import GameCharacterView from "./GameCharacterView";
import NarrativeEventDiceRollView from "./NarrativeEventDiceRollView";

export interface LoadedGameViewArgs extends LoggedInAppArgs {
    game: GameData;
    phase: GamePhase;
    prompt?: FalloutPrompt;
    startOpenFire: (args: OpenFireRequest) => Promise<void>;
    startBrawl: (characterId: string, weaponId: string, targetId: string) => Promise<void>;
    actionPrompt: PromptTakeAction;
    diceRolls: BroadcastDiceRollResults[];

    loggedInUser: LoggedInUser;
    setModalContent: (content: ModalContent | null) => void;
    passHandler: () => void;
    endTurnHandler: () => void;
    resetHandler: () => void;
    round?: number;
    submitGetMoving: (characterId: string, movementOrderCharacterIds: string[]) => void;
    submitBackOff: (characterId: string) => void;
    submitPatchUp: (characterId: string) => void;
    submitDevForcePosition: (characterId: string, position: Vector3, rotation: Quaternion) => void;
    submitRotateCharacter: (characterId: string, rotation: Quaternion) => void;
    narrativeEvents: NarrativeEvent[];
}

const LoadedGameView: React.FC<LoadedGameViewArgs> = (args) => {


    return <div className={styles.loadedGame}>
        <GameHeaderView
            gameId={args.game.id}
            phase={args.phase}
            prompt={args.prompt}
            players={args.game.falloutPlayers}
            loggedInUserId={args.loggedInUser.userId}
            actionPrompt={args.actionPrompt}
            passHandler={args.passHandler}
            endTurnHandler={args.endTurnHandler}
            resetHandler={args.resetHandler}
            round={args.round}
        />
        {/* <button onClick={async e => {
            await closeConnection();
        }}>Close Connection</button> */}
        <ul className={styles.teamList}>
            {args.game.falloutPlayers.sort((a, b) => a.userId === args.loggedInUser.userId ? -1 : 1).map(player => {
                const isYou = player.userId === args.loggedInUser.userId;
                const army = player.crew;
                return <li className={`${styles.crew} ${player.userId === args.prompt?.promptedPlayerUserId ? styles.prompted : ""}`}>
                    <GamePlayerView
                        isOnline={player.isOnline}
                        username={player.username}
                        avatar={player.avatar}
                        isYou={isYou}
                        id={player.userId}
                        crewName={player.crew.name}
                        reputation={player.crew.reputation}
                        colorHex={player.colorHex}
                    />
                    {player.crew && <ul className={styles.characterList}>
                        {army.characters.sort((a, b) => b.rating - a.rating).map(c => <GameCharacterView
                            character={c}
                            isYou={isYou}
                            setModalContent={args.setModalContent}
                            game={args.game}
                            player={player}
                            startOpenFire={args.startOpenFire}
                            startBrawl={args.startBrawl}
                            actionPrompt={args.actionPrompt}
                            submitGetMoving={args.submitGetMoving}
                            submitBackOff={args.submitBackOff}
                            submitPatchUp={args.submitPatchUp}
                            submitDevForcePosition={args.submitDevForcePosition}
                            submitRotateCharacter={args.submitRotateCharacter}
                        />)}
                    </ul>}
                </li>
            })}
        </ul>
        <ul>
            {args.narrativeEvents.map(e => {
                const diceRollResults = e.diceResults ? <NarrativeEventDiceRollView results={e.diceResults} /> : null;
                return <li>
                    <h3>{e.message}</h3>
                    {e.flavorMessage && <p>{e.flavorMessage}</p>}
                    {e.harm && <p>{e.harm} Harm</p>}
                    {e.injury && <p>{e.injury} Injury</p>}
                    {e.fatigue && <p>{e.fatigue} Fatigue</p>}
                    {diceRollResults}
                </li>
            })}
        </ul>
        {/* <ul>
            {args.diceRolls.map(r => {
                var player = args.game.falloutPlayers.find(p => p.userId === r.playerUserId);
                if (!player) {
                    return null;
                }
                return <DiceRollResultsView results={r} player={player} />
            })}
        </ul> */}
    </div>
}


export default LoadedGameView;